import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from "gatsby";
import { pagePath } from '../../helpers/page-path';
import Layout from "../../components/layout";
import SEO from "../../components/seo";
import StorybookIframe from '../../components/storybook-iframe';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout currentPath={pagePath(props.location)} mdxType="Layout">
      <SEO title="Rewards DS | Brand Guidelines | Visual Identity" mdxType="SEO" />
      <div className="docs">
        <h1>{`Visual Identity`}</h1>
  <div className="docs-subtitle">
    Specifications and usage principles for the logo, colour, typography, brand system, graphic assets, co-branding, call to action and illustration.
  </div>
  <div className="columns p-sm-0 is-variable is-multiline is-2" style={{
          maxWidth: '',
          margin: 'auto'
        }}>
    <rds-card-grid {...{
            icon: "fal fa-paint-brush",
            class: "column is-one-third-fullhd is-half-tablet is-one-third-desktop is-full-mobile",
            'card-title': 'Logo',
            link: "/brand-guidelines/visual-identity/logo/",
            'card-description': 'Color conveys personality, sets a tone, attracts attention, and indicates importance.'
          }}></rds-card-grid>
    <rds-card-grid {...{
            icon: "fal fa-paint-brush",
            class: "column is-one-third-fullhd is-half-tablet is-one-third-desktop is-full-mobile",
            'card-title': 'Colour',
            link: "../../product/?path=/docs/tokens-colour--tokens",
            'card-description': 'Color conveys personality, sets a tone, attracts attention, and indicates importance.'
          }}></rds-card-grid>
    <rds-card-grid {...{
            icon: "fal fa-font-case",
            class: "column is-one-third-fullhd is-half-tablet is-one-third-desktop is-full-mobile",
            'card-title': 'Typography',
            link: "../../product/?path=/docs/tokens-typography--tokens",
            'card-description': 'Typography means understanding the relationship between font family, font size, and line height.'
          }}></rds-card-grid>
    <rds-card-grid {...{
            icon: "fal fa-ruler-horizontal",
            class: "column is-one-third-fullhd is-half-tablet is-one-third-desktop is-full-mobile",
            'card-title': 'Spacing',
            link: "../../product/?path=/docs/tokens-spacing--tokens",
            'card-description': 'A standard set of sizes to handle spacing within elements, components, and views.'
          }}></rds-card-grid>
  </div>
      </div>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      